import { Link } from "gatsby";
import BlockText from "../block-content/block-text";
import { imageUrlFor } from "../../lib/image-url";

function MenuItem(props) {
  const iconRef = props?.linkIcon?.asset?._ref;
  const imageRef = props?.linkImage?.asset?._ref;
  const labelClass = props.linkSize === 'small' ? 'text-sm' : '';
  return (
    <a
      className={props?.overrideClass ? props.overrideClass : `${props?.linkDark ? 'text-yellow-500' : ''} flex group flex-wrap rounded ${props.linkClass}`}
      key={props.linkKey}
      href={props.linkUrl}
      onClick={props.toggleFunction}
    >
      <div className="flex">
        {iconRef &&
          <span className="w-2/12 mr-4">
            <img alt={props?.linkIcon?.alt} width="50" height="50" src={imageUrlFor(iconRef).auto("format").width(100).quality(80).url()} />
          </span>
        }
        <div className={`w-${iconRef ? 10 : 12}/12`}>
           {props.linkUrl ?
            <span className={`${props?.linkDark ? 'text-yellow-500' : 'text-blue-500'} ${props?.linkInline ? 'text-xs' : ''} tracking-tight ${imageRef ? '' : 'group-hover:underline'} font-bold ${labelClass}`}>{props.linkText}</span> 
            : <h2 className={`${props?.linkDark ? 'text-yellow-500' : 'text-gray-500'} uppercase font-bold tracking-wide text-xs mt-2 mb-1 ${labelClass}`}>{props.linkText}</h2> 
            }
            {props.linkDescription &&
              <div className={`text-xs leading-tight ${props?.linkDark ? 'text-white' : 'text-gray-500'} `}>{typeof props.linkDescription === 'object' ? <BlockText isPlain={true} blocks={props.linkDescription} /> : props.linkDescription }</div>
            }
            {imageRef && 
              <div className='w-full shadow'>
                <img alt={props?.imageRef?.alt} src={imageUrlFor(imageRef).auto("format").width(800).quality(80).url()} />
              </div>
            }
        </div>
      </div>

    </a>
  );
}

export default MenuItem;
